module.exports = __webpack_public_path__ + "img/history.ade7ffe6.svg";